import { MainHeader } from '../../components/section/MainHeader';
import VideoPlayer from '../../components/section/VideoPlayer';
import ModuleSection from '../../components/section/ModuleSection';
import SectionBlueAndCartel from '../../components/section/SectionBlueAndCartel';
import { t } from '../../translation/translation';
import { TEXT_KEYS } from '../../constants/textKeys';
import IMAGES_PATH from '../../Images';
import SectionMozaic from '../../components/section/SectionMozaic';
import SectionProgressBar from '../../components/section/SectionProgressBar';
import SectionSignUp from '../../components/section/SectionSignUp';
import React from 'react';

const CARTEL_ITEMS = [
  {
    icon: IMAGES_PATH.ICON_CHART,
    title: <h4 className="styled-h4">{t(TEXT_KEYS.HOME_BLUE_CARTEL_TITLE_1)}</h4>,
    description: t(TEXT_KEYS.HOME_BLUE_CARTEL_DESCRIPTION_1),
  },
  {
    icon: IMAGES_PATH.ICON_ACTIVITY,
    title: <h4 className="styled-h4">{t(TEXT_KEYS.HOME_BLUE_CARTEL_TITLE_2)}</h4>,
    description: t(TEXT_KEYS.HOME_BLUE_CARTEL_DESCRIPTION_2),
  },
  {
    icon: IMAGES_PATH.ICON_EURO,
    title: <h4 className="styled-h4">{t(TEXT_KEYS.HOME_BLUE_CARTEL_TITLE_3)}</h4>,
    description: t(TEXT_KEYS.HOME_BLUE_CARTEL_DESCRIPTION_3),
  },
];

const Home = () => {
  return (
    <div className='page-container'>
      <MainHeader />
      <VideoPlayer />
      <ModuleSection />
      <SectionBlueAndCartel
        subtitle={t(TEXT_KEYS.HOME_BLUE_CARTEL_SUBTITLE)}
        title={t(TEXT_KEYS.HOME_BLUE_CARTEL_TITLE)}
        buttonLabel={t(TEXT_KEYS.HOME_BLUE_CARTEL_BUTTON)}
        cartelItems={CARTEL_ITEMS}
      />
      <SectionMozaic />
      <SectionProgressBar />
      <SectionSignUp />
    </div>
  );
};

export default Home;